import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Directly set scroll position to top
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant" // This ensures immediate jump to top
    });
    
    // Also reset body scroll
    document.body.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant"
    });
  }, [pathname]);

  return null;
}

export default ScrollToTop;